import React from "react";
import { useGetRegistryOrganizationDetailsQuery } from "./store/registryorgapi";
import { useGetRegistryUserDetailsQuery } from "./store/registryuserapi";
import { skipToken } from "@reduxjs/toolkit/query";

interface RegistryDisplayOrganizationNameProps {
  orgid?: string | string[];
  userid?: string;
  place?: string;
}

export const RegistryDisplayOrganizationName: React.FC<
  RegistryDisplayOrganizationNameProps
> = ({ orgid, userid, place }) => {
  const { data: userOrgId } = useGetRegistryUserDetailsQuery(
    userid ?? skipToken
  );

  const { data, isLoading: isOrgDetailsLoading } =
    useGetRegistryOrganizationDetailsQuery(
      orgid ?? userOrgId?.organization ?? skipToken
    );
  if (!isOrgDetailsLoading) {
  }
  return (
    <>
      {!isOrgDetailsLoading && (
        <>
          {data?.organization}
        </>
      )}
    </>
  );
};
